module.exports = __webpack_public_path__ + "img/widgets8.78ca25f4.png";